<template>
  <div id="contents">
    <div class="recruit_pinch" v-if="pinch_post">
      <div class="recruit_pinch_main" :class="[pinch_post.style_name]">
        <div class="title_area">
          <p class="title">入社史上最大のピンチ<span class="small">〜こうやって乗り越えた〜</span></p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" alt="" />
        </div>
        <p class="caption">{{ pinch_post.caption }}</p>
        <div class="main_image">
          <p class="img"><img :src="pinch_post.main_img" alt="" /></p>
          <div class="profile">
            <p class="name_jp">{{ pinch_post.name_jp }}</p>
            <p class="name_en">{{ pinch_post.name_en }}</p>
            <p class="desc" v-html="pinch_post.desc"></p>
          </div>
        </div>
        <div class="article_wrap miyazawa_bg">
          <div class="article" v-for="article in pinch_post.article" :key="article.id">
            <div class="title">
              <p>{{ article.title }}</p>
            </div>
            <div class="content" v-for="content in article.content" :key="content.id">
              <p class="text" v-html="content.text"></p>
              <p class="img" :class="content.img_class" v-if="content.img_flg"><img :src="content.img_url" alt=""></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
import pinch_post_list from './js/recruit_pinch.json'
export default {
  name: 'recruit_pinch',
  data() {
    return {
      pinch_post_list: pinch_post_list,
      pinch_post: null,
      request_id: this.$route.params.id,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    this.fetch_pinch_post(this.$route.params.id)
  },
  methods: {
    fetch_pinch_post(request_id){
      this.pinch_post = this.pinch_post_list[request_id]
      if (this.post_type != 'all'){
        setTimeout(() => {
          if (this.link){
            var speed = 1500;
            var href = this.link
            var target = $('#' + href)
            var position = target.offset().top - 50;
            $('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
          }
        }, 300);
      }
    },
    reload_model(post_id, layout) {
      var post = this.young_post_list.find(post => post.id == post_id);
      if (post != null){
        this.$emit('reload_model', post_id, layout);
      }
    },
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_pinch
    &_main
      width: 1000px
      margin: 161px auto 150px
      padding-bottom: 75px
      background-color: #fff
      position: relative
      &.miyazawa
        .article_wrap
          background-image: url("../assets/img/common/recruit_2022/pinch/miyazawa_bg.png")
      &.miura
        .title
          background: #FF7689
        .main_image
          padding: 0 99px 0 78px
          .profile
            top: 208px
            left: 599px
            .name_jp
              background: #FF7689
            .name_en
              background: #FF7689
        .article_wrap
          background-image: url("../assets/img/common/recruit_2022/pinch/miura_bg.png")
          .article
            .title
              background: #FF7689
      &.nakazawa
        .title
          background: #FFEF76
        .main_image
          padding: 0 99px 0 78px
          .profile
            top: 203px
            left: 570px
            .name_jp
              background: #FFEF76
            .name_en
              background: #FFEF76
            .desc
              width: 273px
        .article_wrap
          background-image: url("../assets/img/common/recruit_2022/pinch/nakazawa_bg.png")
          .article
            .title
              background: #FFEF76
      &.takagi
        .title
          background: #A5FF76
        .main_image
          padding: 0 99px 0 78px
          .profile
            top: 203px
            left: 585px
            .name_jp
              background: #A5FF76
            .name_en
              background: #A5FF76
            .desc
              width: 273px
              margin: 29px 0 0
              color: #003A6F
        .article_wrap
          background-image: url("../assets/img/common/recruit_2023/pinch/takagi_bg.png")
          .article
            .title
              background: #A5FF76
      &.hosoda
        .title
          background: #54D163
        .main_image
          padding: 0 99px 0 78px
          .profile
            top: 190px
            left: 134px
            .name_jp
              background: #54D163
            .name_en
              padding: 0 28px 2px 7px
              background: #54D163
            .desc
              z-index: 1
              width: 232px
        .article_wrap
          min-height: 931px
          background-image: url("../assets/img/common/recruit_2024/pinch/hosoda_bg.png")
          background-position: top center
          .article
            .title
              background: #54D163
      .title_area
        position: absolute
        top: -49px
        left: 55px
      .title
        @include recruit_font(41px, 64px, .176em)
        display: flex
        align-items: center
        color: #003A6F
        background: #FFA700
        padding: 5px 19px 9px 18px
        .small
          @include recruit_font(20px, 50px, .176em)
          margin: 8px 20px 0 20px
      .close_icon
        position: absolute
        right: 0px
        top: -65px
        img
          width: 40px
          height: 40px
      .caption
        @include recruit_font(14px, 1.8em, .107em)
        color: #003A6F
        display: inline-block
        margin: 72px 91px 37px
      .main_image
        position: relative
        margin: 0 auto 60px
        padding: 0 99px
        img
          width: 100%
        .profile
          position: absolute
          top: 208px
          left: 157px
          .name_jp
            @include recruit_font(32px, 47px, .176em)
            display: table
            padding: 0 7px
            background: #FFA700
            color: #003A6F
          .name_en
            @include recruit_font(18px, 27px, .05em)
            display: table
            padding: 0 7px 2px
            background: #FFA700
            color: #003A6F
          .desc
            @include recruit_font(10px, 1.7em, .05em)
            color: #fff
            width: 256px
            margin: 12px 0 0
      .article_wrap
        background-image: url("../assets/img/common/recruit_2022/pinch/miyazawa_bg.png")
        background-repeat: no-repeat
        background-size: contain
        background-position: center
        .article
          position: relative
          padding: 102px 55px 64px
          &:last-child
            padding: 102px 55px 0
          .title
            @include recruit_font(29px, 66px, 0.176em)
            position: absolute
            top: 0
            left: -27px
            padding: 0 20px 0 63px
            background: #FFA700
            color: #003A6F
          .content
            display: flex
            justify-content: space-between
            margin: 14px 0 0
            &:first-child
              margin: 0
            .text
              @include recruit_font(14px, 2.2em, 0.072em)
              width: 100%
              color: #003A6F
            .img
              img
                width: 100%
            .miyazawa_01_00
              width: 293px
              margin: 8px 0 0 40px
            .hosoda_02_00
              width: 403px
              margin: -24px -2px 0 20px
</style>



// WEBPACK FOOTER //
// src/components/recruit_pinch.vue